import React from 'react'
import GoogleMapReact from 'google-map-react'
const K_WIDTH = 40
const K_HEIGHT = 40


const MapMarker = ({ text }: { text: string; lat: number; lng: number }) => (
  <div
    style={{
      // initially any map object has left top corner at lat lng coordinates
      // it's on you to set object origin to 0,0 coordinates
      width: K_WIDTH,
      height: K_HEIGHT,
      left: -K_WIDTH / 2,
      top: -K_HEIGHT / 2,
      border: '5px solid #f44336',
      borderRadius: K_HEIGHT,
      backgroundColor: 'white',
      textAlign: 'center',
      color: '#3f51b5',
      fontSize: 16,
      fontWeight: 'bold',
      padding: 4,
    }}
  >
    {text}
  </div>
)

export default function GMap({ lat, lng, markerText }: { lat: number, lng: number, markerText: string }) {
  const defaultProps = {
    center: {
      lat,
      lng,
    },
    zoom: 11,
  }

  return (
    // Important! Always set the container height explicitly
    <div style={{ height: '50vh', width: '100%' }}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: '' }}
        defaultCenter={defaultProps.center}
        defaultZoom={defaultProps.zoom}
      >
        <MapMarker lat={lat} lng={lng} text={markerText} />
      </GoogleMapReact>
    </div>
  )
}
